import { z } from '@harvestiq/zod';
import { claimSchema } from './claim';
import { dbClaimSchema, dbClaimUpdateSchema } from './db-claims';

// request types
export const updateClaimRequestParamsSchema = dbClaimSchema.pick({
  id: true,
});
export type UpdateClaimRequestParams = z.infer<
  typeof updateClaimRequestParamsSchema
>;
export const updateClaimRequestBodySchema = dbClaimUpdateSchema.pick({
  claimNumber: true,
  notes: true,
});
export type UpdateClaimRequestBody = z.infer<
  typeof updateClaimRequestBodySchema
>;

// response types
export const updateClaimResponseSchema = z.object({
  claim: claimSchema.optional(),
  error: z.string().optional(),
});

export type UpdateClaimResponse = z.infer<typeof updateClaimResponseSchema>;
